export default __webpack_public_path__ + "static/media/cameraObstruction.9e6dbfe6.png";